module.exports = __webpack_public_path__ + "static/media/certi.c1232c4b.svg";